"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className="w-full bg-background border-t border-border py-8">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-opacity duration-[var(--duration-slow)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
        {}
        <nav className="flex justify-center items-center gap-6 mb-6">
          <Link to="/HomePage" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-foreground hover:after:w-full after:transition-all after:duration-200">
            Home
          </Link>
        </nav>

        {}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 text-center">
          <p className="text-xs text-muted-foreground">Copyright © 2026 Practice Growth Consultants - All Rights Reserved.</p>
          <svg className="h-4 w-auto opacity-70" viewBox="0 0 120 30" fill="currentColor" aria-label="GoDaddy">
            <path d="M20 15c0 5.523-4.477 10-10 10S0 20.523 0 15 4.477 5 10 5s10 4.477 10 10zm-5 0c0-2.761-2.239-5-5-5s-5 2.239-5 5 2.239 5 5 5 5-2.239 5-5z" />
            <path d="M35 8h5v14h-5V8zm0-6h5v4h-5V2zM55 8c3.866 0 7 3.134 7 7s-3.134 7-7 7h-3v6h-5V8h8zm0 10c1.657 0 3-1.343 3-3s-1.343-3-3-3h-3v6h3zM75 8h5v14h-5V8zm0-6h5v4h-5V2zM95 8c3.866 0 7 3.134 7 7s-3.134 7-7 7h-3v6h-5V8h8zm0 10c1.657 0 3-1.343 3-3s-1.343-3-3-3h-3v6h3z" />
          </svg>
        </div>
      </div>
    </footer>;
}